import IconHouseSolid from '@/assets/icons/font_awesome/house-solid.svg?react';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_user } from '@/hooks/store/use_slices';
import { toast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { REMOTE__user_settings_update } from '@/state/user/settings/REMOTE__user_settings_update';
import { DTO__workspace } from '@shared/dto/+workspace/workspace_entity/DTO__workspace';
import { useTranslation } from 'react-i18next';

interface Props {
  workspace: DTO__workspace;
}

export const ButtonWorkspaceSetDefault = ({ workspace }: Props) => {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const dispatch = use_dispatch();

  const { user_settings } = use_slice_user(['user_settings']);

  /*
   * EVENTS
   */

  const onClick = async (e: React.MouseEvent) => {
    e.stopPropagation();

    if (workspace._id == user_settings.default_workspace_id) return;

    const settings_new = user_settings.clone({ default_workspace_id: workspace._id });

    await dispatch(REMOTE__user_settings_update(settings_new));

    toast({ title: t(i18n_base_ui.toasts.update_default_workspace.title) });
  };

  /*
   * RENDERS
   */

  if (workspace._id === user_settings.default_workspace_id) return <></>;

  return (
    <span
      className="absolute size-full backdrop-blur-sm backdrop-brightness-50 opacity-0 hover:opacity-100 cursor-pointer flex items-center justify-center"
      onClick={onClick}
    >
      <IconHouseSolid className="size-5" />
    </span>
  );
};
